.item[data-selection-mode] .checkbox {
  grid-area: check;
}

.item[data-selection-mode] .icon {
  grid-area: icon;
}

.item:not([data-selection-mode]) .icon {
  grid-area: check / check / icon / icon;
}

.item[data-disabled] .icon {
  filter: grayscale(100%) opacity(50%);
}

.checkbox:has(input[type='checkbox']) {
  scale: 0.8;
  transform-origin: left;
}

.icon {
  color: var(--color__gray-500);
}

.svg {
  inline-size: 1rem;
  block-size: 1rem;
}
